import React, { useEffect, useState } from "react";
import ProductCard from "../../../Hook/Pc";
import CpuIcon from "../../../Hook/icone/cpu.png";
import RamIcon from "../../../Hook/icone/ram.png";
import SsdIcon from "../../../Hook/icone/ssd.png";
import GpuIcon from "../../../Hook/icone/gpu.png";
import { useNavigate } from "react-router-dom";
import "../Ordinateur.css";

const Serveur = () => {
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);

    useEffect(() => {
        fetch("https://www.amservices.eu/api/products_serveur.php")
            .then(res => res.json())
            .then(data => setProducts(Array.isArray(data) ? data : []))
            .catch(console.error);
    }, []);

    return (
        <>
            <h1 className="sr-only">Serveurs professionnels personnalisables</h1>
            <h2 className="section-title">Nos Serveurs</h2>

            <div className="product-list">
                {products.map(product => {
                    const cpu = product.specs?.[0] || "";
                    const ram = product.specs?.[1] || "";
                    const stockage = product.specs?.[2] || "";
                    const reseau = product.specs?.[3] || "";

                    const specs = [
                        { icon: CpuIcon, label: cpu },
                        { icon: RamIcon, label: ram },
                        { icon: SsdIcon, label: stockage },
                        { icon: GpuIcon, label: reseau },
                    ];

                    return (
                        <div key={product.id} className="product-with-toggle Serveur">
                            <ProductCard
                                img={`https://www.amservices.eu/api/${product.logo}`}
                                alt={product.name}
                                title={product.name}
                                specs={specs}
                                optionText="Tarif sur demande"
                                description={product.description}
                            />
                        </div>
                    );
                })}
            </div>

            <div className="div_btn-retour">
                <div className="btn-telephones" onClick={() => navigate("/ordinateur")}>
                    Retour
                </div>
            </div>
        </>
    );
};

export default Serveur;
